import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const BusinessesPage = () => {
  return <SanityContentPage slug='businesses' />
}

export default BusinessesPage
